import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Page de validation du flux A (« pull ») de la connexion par QR code — ouverte par le
 * téléphone déjà connecté quand il scanne le QR affiché sur le poste non connecté.
 * `pharmedigroup-api/docs/QR_LOGIN.md`.
 *
 * Accessible à TOUT utilisateur authentifié, quel que soit son rôle : c'est de
 * l'authentification transverse, pas un module métier (cf. `.claude/rules/country-scope-front.md`,
 * exception explicitement actée pour cette fonctionnalité). `roles` porte donc la totalité
 * des rôles connus — la garde de route (`withAuthSync`) exige une intersection non vide
 * avec les rôles réels de l'utilisateur, jamais une liste vide (qui bloquerait tout le monde).
 * `entity: PHARMEDIGROUP` couvre FR/BE/LU/IT dans `ENTITY_COUNTRIES`, soit tous les pays
 * ouverts sur la plateforme : aucune restriction pays supplémentaire à poser ici.
 *
 * Hors menu (`menuHeader: false`) : jamais un lien, toujours atteinte par le contenu du QR.
 * Un utilisateur de l'espace labo (SPACE.INDUSTRY) l'ouvre normalement : cette page n'est PAS
 * sous `/industryoffice/*`, `IndustryRoleProvider` (qui gate l'accès direct par URL en espace
 * labo) ne l'englobe donc pas — voir `lib/industry/IndustryRoleContext.tsx`.
 *
 * `utility: true` est OBLIGATOIRE (cf. `isUtilityRoute`) : ouverte à tous les rôles, cette route
 * était la seule page Group d'un compte comptoir. Elle lui attribuait l'entité Group et devenait
 * sa page d'accueil — le Companion s'ouvrait sur « Ce QR code n'est plus valide » (28/09/2026).
 */
export const getFrontOfficeQrLoginAllUser = [
  {
    route: 'QrLoginApprove',
    text: 'Connexion par QR code',
    href: '/frontoffice/qr-login',
    menuHeader: false,
    utility: true,
    entity: [EntityList.PHARMEDIGROUP],
    roles: Object.values(CONSTANTS),
  },
]
